﻿import { upOrDownOnScrollWheel } from "./HelperFunctions";

export function scrollHandler($: JQueryStatic): void {
    const body = document.querySelector("body");

    if (!body) return;

    if (body.classList.contains("page-post-results")) {
        const postFilters: HTMLElement | null = document.querySelector(
            ".page-post-results__filters-container"
        );
        if (postFilters) {
            upOrDownOnScrollWheel(postFilters);
        }
    }
    if (body.classList.contains("job-results")) {
        const jobFilters: HTMLElement | null = document.querySelector(
            ".job-results__filters-container"
        );

        if (jobFilters) {
            upOrDownOnScrollWheel(jobFilters);
        }
    }
}


export const jobFiltersLocationClickHandler = () => {
    const filter = document.querySelector<HTMLDivElement>('.job-results .location-filter')
    if (!filter) return

    const filterHeader = filter.querySelector<HTMLHeadingElement>('.header')
    if (!filterHeader) return

    filterHeader.addEventListener('click', () => {
        filter.classList.toggle('category-opened')
    })
}


export const postFiltersBtnClickHandler = () => {
    const filterButton = document.querySelector<HTMLElement>(".page-post-results__filter-btn");
    const filterWrapper = document.querySelector<HTMLElement>(".page-post-results__filter-wrapper");

    if (!filterButton || !filterWrapper) return;
    

    filterButton.addEventListener("click", () => {
            filterWrapper.classList.toggle("page-post-results__filter-wrapper--open");
            filterButton.setAttribute("aria-expanded", filterButton.getAttribute("aria-expanded") === "true" ? "false" : "true");
            filterButton.classList.toggle("page-post-results__filter-btn--active");
            filterButton.setAttribute("aria-label", filterButton.getAttribute("aria-label") === "close" ? "open filters" : "close filters");
    });
};

export const jobFiltersCloseSalarySlider = () => {
    const salaryFilter = document.querySelector<HTMLElement>('.job-results .job-results__filters-container .search-filters-widget__filter-list .salary-slider__header');
    const salaryToggle = document.querySelector<HTMLElement>('.job-results .job-results__filters-container .search-filters-widget__filter-list .salary-slider__container');
    const jobFilters = document.querySelectorAll<HTMLElement>('.job-results .job-results__filters-container .search-filters-widget__filter-list .option-display-list');

    if (!salaryFilter || !salaryToggle || !jobFilters.length) return;

    jobFilters.forEach(filter => {
        const observer = new MutationObserver(() => {
            if (filter.classList.contains('option-display-list--open')) {
                if (salaryFilter.classList.contains('open')) {
                    salaryFilter.classList.remove('open');
                    salaryToggle.style.display = 'none';
                }
            }
        });

        observer.observe(filter, {
            attributes: true,
            attributeFilter: ['class']
        });
    });
}